import { Box, Stack, Typography } from "@mui/material";
import ColorEdit from "../../../common/ColorEdit";
import SectionTitle from "./SectionTitle";

interface Props {
  title: string;
  subtitle: string;
  color: string;
  disabled?: boolean;
  onChange: (newColor: string) => void;
}

const EditColorSection = ({ title, subtitle, color, onChange, disabled }: Props) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
    <SectionTitle text={title} description={subtitle} />
    <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
      <Typography color="textSecondary">{color.toUpperCase()}</Typography>
      <ColorEdit
        disabled={disabled}
        color={color}
        onColorChange={onChange}
        popoverProps={{
          anchorOrigin: { vertical: "center", horizontal: "right" },
          transformOrigin: { vertical: "center", horizontal: "left" },
        }}
      />
    </Stack>
  </Box>
);

export default EditColorSection;
